var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3951A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 39.9995C31.0457 39.9995 40 31.0452 40 19.9995C40 16.5554 39.1295 13.3147 37.5965 10.4854C34.0807 7.41486 29.4807 5.55469 24.4463 5.55469C13.4006 5.55469 4.44629 14.509 4.44629 25.5547C4.44629 28.9987 5.31682 32.2394 6.84983 35.0688C10.3655 38.1393 14.9655 39.9995 20 39.9995Z",
    fill: "#4A60AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8673_49563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.82 17.2715C10.3164 17.2715 9.09277 18.4951 9.09277 19.9988C9.09277 21.5024 10.3164 22.726 11.82 22.726C13.3237 22.726 14.5473 21.5024 14.5473 19.9988C14.5473 18.4951 13.3237 17.2715 11.82 17.2715ZM11.82 21.817C10.8173 21.817 10.0019 21.0015 10.0019 19.9988C10.0019 18.996 10.8173 18.1806 11.82 18.1806C12.8228 18.1806 13.6382 18.996 13.6382 19.9988C13.6382 21.0015 12.8228 21.817 11.82 21.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 17.2715C18.4981 17.2715 17.2744 18.4951 17.2744 19.9988C17.2744 21.5024 18.4981 22.726 20.0017 22.726C21.5053 22.726 22.729 21.5024 22.729 19.9988C22.729 18.4951 21.5053 17.2715 20.0017 17.2715ZM20.0017 21.817C18.9989 21.817 18.1835 21.0015 18.1835 19.9988C18.1835 18.996 18.9989 18.1806 20.0017 18.1806C21.0044 18.1806 21.8199 18.996 21.8199 19.9988C21.8199 21.0015 21.0044 21.817 20.0017 21.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1833 17.2715C26.6797 17.2715 25.4561 18.4951 25.4561 19.9988C25.4561 21.5024 26.6797 22.726 28.1833 22.726C29.6869 22.726 30.9106 21.5024 30.9106 19.9988C30.9106 18.4951 29.6869 17.2715 28.1833 17.2715ZM28.1833 21.817C27.1806 21.817 26.3651 21.0015 26.3651 19.9988C26.3651 18.996 27.1806 18.1806 28.1833 18.1806C29.1861 18.1806 30.0015 18.996 30.0015 19.9988C30.0015 21.0015 29.1861 21.817 28.1833 21.817Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8673_49563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(9.09277 9.08984)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.14b0cbc00a788a223d546b6decf1374a.svg";
export { ForwardRef as ReactComponent };